<template>
  <div class="bodys">
    <div class="container">
      <h1>
        会社概要
      </h1>
      <h2 class="company">DIRECT PROVIDER CO., LIMITED</h2>

      <table class="">
        <tr>
          <td>所在地</td>
          <td>9/F BULKIN CENTRE 332-334 PORTLAND STREET MONGKOK KL</td>
        </tr>
        <tr>
          <td>資本金</td>
          <td>3,000,000 HKD</td>
        </tr>
        <tr>
          <td>設立年月日</td>
          <td>2016-09</td>
        </tr>
        <tr>
          <td>HP</td>
          <td>http://www.j-direct.com</td>
        </tr>

        <tr>
          <td>Email</td>
          <td>info@d-provider.com</td>
        </tr>
        <tr>
          <td>事業内容</td>
          <td align="left">
            １．国際間専用回線、VPNプロバイダーサービス<br />
            ２．通信製品の開発、販売<br />
          </td>
        </tr>
      </table>

      <h2 class="company text-center">&nbsp;</h2>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  components: {},
  methods: {},
  mounted() {},
};
</script>
<style scoped>
.bodys {
  margin: 0 auto;
  width: 1170px;
  height: 66.8vh;
  margin-top: 80px;
  margin-bottom: 80px;
  padding-top: 1px;
}
h1, .h1, h2, .h2, h3, .h3 {
  margin-top: 20px;
  margin-bottom: 10px;
}
.container{
  width: 100%;
  text-align: center;
  margin: 0 auto;
}
.container h1 {
  margin-top: 2em;
  margin-bottom: 1em;
  font-size: 36px;
  font-family: inherit;
  font-weight: 500;
  line-height: 1.1;
  color: inherit;
}
.container .company {
  font-family: inherit;
  font-weight: 500;
  line-height: 1.1;
  color: inherit;
}
.container table {
  width: 60%;
  margin: 0 auto;
  margin-bottom: 4em;
  border-spacing: 0;
}
table tr td {
  border: 1px solid #ddd;
}
.container table td:first-child, #exhi table td:first-child {
  padding: 10px;
  line-height: 1.42857;
  vertical-align: top;
  border-top: 1px solid #ddd;
  width: 30%;
  background: #00659b;
  color: #fff;
}
</style>


// WEBPACK FOOTER //
// src/components/corporate/index.vue